import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { FC } from 'react';

const useStyles = makeStyles({
  root: {
    padding: 24,
    background: 'linear-gradient(0deg, rgba(124,33,103,1) 0%, rgba(178,69,153,1) 60%)',
    color: 'white',
  },
});

const Header: FC = ({ children }) => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <Typography variant="h5" component="h2">
        {children}
      </Typography>
    </div>
  );
};

export default Header;
